import { REACT_QUERY_KEYS } from '@/constants'
import { type ShipmentOrdersRequestQuery } from '@/libs/api/types'

export const shipmentOrderHistoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_ORDER_HISTORIES] as const,
  select: (tenantKey: string) =>
    [...shipmentOrderHistoriesQueryKeys.all, 'select', tenantKey] as const,
  detail: (tenantKey: string, id: number) =>
    [...shipmentOrderHistoriesQueryKeys.all, 'detail', tenantKey, id] as const
}

export const shipmentOrdersQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_ORDERS] as const,
  regularGroup: (tenantKey: string, regularGroupId: string) =>
    [
      ...shipmentOrdersQueryKeys.all,
      'regularGroup',
      tenantKey,
      regularGroupId
    ] as const,
  bundle: (tenantKey: string, bundleId: number) =>
    [...shipmentOrdersQueryKeys.all, 'bundle', tenantKey, bundleId] as const,
  // #5285 2.1: 検索結果サマリー。summaryAll は一覧を再取得する操作でまとめて invalidate するための接頭辞
  summaryAll: (tenantKey: string) =>
    [...shipmentOrdersQueryKeys.all, 'summary', tenantKey] as const,
  summary: (tenantKey: string, query: ShipmentOrdersRequestQuery) =>
    [...shipmentOrdersQueryKeys.summaryAll(tenantKey), query] as const
}
